// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-btn[data-v-26feddd9] {\n  font-size: var(--fs-input);\n  margin-top: 0.1rem;\n  margin-bottom: 0.1rem;\n  min-height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
